
























import { Component, Vue } from 'vue-property-decorator';
import { getNewsList } from "@/req/homes";

@Component({
  components: {}
})
export default class Home extends Vue {
  public newsList = []
  public pagination = {
    current: 1,
    pageSize: 6,
    total: 0
  }
  /**
   * changeCurrent
   * 换页
   */
  public changeCurrent(page) {
    this.pagination.current = page;
    this.initNewsList()
  }
  /**
   * detail
   */
  public detail(id) {
    this.$router.push({
      path: '/news/detail',
      query: {id}
    })
  }
  /**
   * 获取新闻列表
   */
  public initNewsList() {
    const params = {
      page: this.pagination.current,
      limit: this.pagination.pageSize
    }
    getNewsList(params).then(res => {
      this.newsList = res.data.data;
      this.pagination.total = res.data.total;
    })
  }
  public mounted() {
    this.initNewsList()
  }
}
